import { NoResultsRoot } from 'src/common/components/ConfigurableTable/Components/NoRowsOverlay';
import { useTranslation } from 'react-i18next';
import Typography from "@mui/material/Typography";
import NotFoundSmall from 'assets/images/notFoundSmall.png';
import { useProductAccountRef } from '../hooks/useProductAccountRef';

export const ProductSummaryNoRows = () => {
  const { t } = useTranslation();
  const accountRef = useProductAccountRef();

  return (
    <NoResultsRoot>
      <img src={NotFoundSmall} alt="" />
      <Typography variant="h3" color="text.secondary">
        {accountRef ? t('common.noResults') : t('productSummary.table.selectAccount')}
      </Typography>
    </NoResultsRoot>
  );
};
